import styles from './EmbedVideo.module.scss'

export default function EmbedVideo(props) {
  // Returns the YouTube video id from the url or null if not found
  const getYoutubeId = (link) => {
    const ytEmbedRegex = /^(.*youtube.com\/embed\/.*)/
    const ytWatchRegex = /^(.*youtube.com\/watch\?v=.*)/
    const ytShorttRegex = /^(.*youtu.be\/.*)/

    if (ytEmbedRegex.test(link)) {
      return link.split('embed/')[1].split('?')[0]
    }

    if (ytWatchRegex.test(link)) {
      return link.split('v=')[1].split('&')[0]
    }

    if (ytShorttRegex.test(link)) {
      return link.split('be/')[1].split('?')[0]
    }

    return null
  }

  const isVimeoLink = (link) => {
    const vimeoRegex = /^(.*vimeo.com\/video\/.*)/
    return vimeoRegex.test(link)
  }

  return (
    <section className={styles.section} id="videoembed">
      <h2 className={styles.title}>Video</h2>
      {getYoutubeId(props.url) !== null && (
        <iframe
          src={`https://www.youtube.com/embed/${getYoutubeId(props.url)}`}
          title="YouTube video player"
          width="100%"
          height="300px"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}

      {isVimeoLink(props.url) && (
        <iframe
          title="vimeo-player"
          src={props.url}
          width="100%"
          height="300px"
          frameBorder="0"
          allowFullScreen
        ></iframe>
      )}
    </section>
  )
}
